import React from 'react';
import moment from "moment";
//import DatatableComponent from './DatatableComponent';
import UserCertificateTable from './UserCertificateTable';

var pfcount = 0;

export default class EmployeeListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            employee: props.registro,
            toggleActivateMtess: props.toggleActivateMtess,
            toggleActivate: props.toggleActivate
        }
    }
    
    render () {

        let data = [];

        for (var i = 0; i < this.state.employee.length; i++) {
            var rows = {
                    cedula: this.state.employee[i].identification,
                    nombres: this.state.employee[i].nombres+" "+this.state.employee[i].apellidos,
                    tipo_certificado: this.state.employee[i].cert_type,
                    fecha_inicial: this.state.employee[i].cert_start != null ? moment(this.state.employee[i].cert_start).format('DD/MM/YYYY HH:mm:ss') : "No estimado",
                    fecha_final: this.state.employee[i].cert_end != null ? moment(this.state.employee[i].cert_end).format('DD/MM/YYYY HH:mm:ss') : "No estimado"
                }
            data.push(rows)
        }

        return (
            <UserCertificateTable 
                key={pfcount++}
                registro={data}>
            </UserCertificateTable>
        )
    }
}